import FileSaver from "file-saver";
import JsZip from "jszip";

type ExportOptions = {
    folderName: string;
};

export type File = {
    name: string;
    fileExtension: string;
    data: Blob | undefined;
};

export async function exportBlobsToZip(blobs: File[], options: ExportOptions) {
    const zip = JsZip();
    blobs.forEach((blob) => {
        if (blob.data) {
            zip.file(`${blob.name}.${blob.fileExtension}`, blob.data);
        }
    });
    await zip.generateAsync({ type: "blob" }).then((zipFile) => {
        const folderName = `${options.folderName}.zip`;
        return FileSaver.saveAs(zipFile, folderName);
    });
}
